import Layout from '@/layout/Index'
export const BigData = [
  {
    path: '/big-data',
    component: Layout,
    children: [
      { path: '', component: () => import(/* webpackChunkName: "home-index" */ './pages/BigDataView.vue'), name: '首页' },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/big-data-view/big-data-view.route.js